import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { messagesApi } from "../../../features/messages/messagesApi";
import Message from "./Message";

export default function Messages({ messages, totalCount, conversationId }) {
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const fetchMoreData = () => {
    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(
        messagesApi.endpoints.getMoreMessages.initiate({
          id: conversationId,
          page,
        })
      );
    }
  }, [page, dispatch, conversationId]);

  useEffect(() => {
    if (totalCount > 0) {
      const more =
        Math.ceil(
          totalCount / Number(process.env.REACT_APP_MESSAGES_LIMIT_PER_PAGE)
        ) > page;

      setHasMore(more);
    }
  }, [page, totalCount]);

  useEffect(() => {
    console.log(page, hasMore)
  }, [page, hasMore])

  return (
    <div
      id="scrollableDiv"
      className="relative w-full h-[calc(100vh_-_197px)] p-6 overflow-y-auto flex flex-col-reverse"
    >
      <ul className="space-y-2">
        <InfiniteScroll
          dataLength={messages?.length}
          next={fetchMoreData}
          style={{ display: "flex", flexDirection: "column-reverse" }} //To put endMessage and loader to the top.
          inverse={true}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          scrollableTarget="scrollableDiv"
        >
          {messages
            .slice()
            .sort((a, b) => b.timestamp - a.timestamp)
            .map((message) => {
              return (
                <div key={message.id}>
                  <Message
                    justify={
                      message.sender.email === user.email ? "end" : "start"
                    }
                    message={message.message}
                  />
                </div>
              );
            })}
        </InfiniteScroll>
      </ul>
    </div>
  );
}
